import React from "react";
import styles from "./GetSection.module.scss";

const GetSection = () => {
  return (
    <>
      <div className={styles.wrapper}>
      <div className={styles.innersection}>
      <div className={styles.section}>
        <div className={styles.container1}>
          <div className={styles.right}>
          <img className={styles.imgContainer} src={"/assets/main-section-phone1.png"} />
          </div>
          <div className={styles.left}>
            <div className={styles.heading}>Get a Free Mobile App</div>
            <div className={styles.text}>
              Access money directly from your balance with our debit cards, or
              easily finance your everyday purchases
            </div>
            <div className={styles.ulsection}>
            <ul>
              <li>Explore our credit cards</li>
              <li>Apply to Source for Early Stage</li>
            </ul>
            </div>
            <div className={styles.imagesdiv}>
              <img src="/assets/app-store.png" alt="App Store" />
              <img
                src="/assets/google-store.png"
                alt="google play"
                className={styles.img2}
              />
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
    </>
  );
};

export default GetSection;

//  
